import React, { useContext, useEffect } from 'react';
import SMLSelect from '../../../../shared/components/SMLSelect';
import { valueToOption } from '../../../../shared/components/FormData';
import { ReportFormContext } from './ReportForm';

const MasterSourceSelect = ({ masterSourceChoices }) => {
  const { formData, handleSelectChange } = useContext(ReportFormContext);

  const options = masterSourceChoices;

  useEffect(() => {
    handleSelectChange('masterSource', null);
  }, []);

  useEffect(() => {
    valueToOption(formData.masterSource, options, (option) => {
      handleSelectChange('masterSource', option);
    });
  }, [formData.masterSource]);

  return (
    <div className="form-group">
      <label>Master Source</label>
      <SMLSelect
        name="masterSource"
        options={options}
        value={formData.masterSource}
        onChange={option => handleSelectChange('masterSource', option)}
        placeholder='Master Source'
        isClearable='true'
      />
    </div>
  );
};

export default MasterSourceSelect;
